import { render, staticRenderFns } from "./Atb.vue?vue&type=template&id=c55c851c&"
import script from "./Atb.vue?vue&type=script&lang=js&"
export * from "./Atb.vue?vue&type=script&lang=js&"
import style0 from "./Atb.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports